import React, { Component } from 'react';
import './KPITable.css';
import classNames from 'classnames';


interface Props {
    title:string
    counter?: number
    search?:boolean
}
interface State{
    toggled:boolean
}

export default class KPITable extends Component<Props, State>{
    constructor(props:Props){
        super(props);

        this.state={
            toggled: true
        }
    }

    render() {
        return (
            <div className={classNames({
                "kpi-table": true,
                "toggled": this.state.toggled
            })}>
                <div className="kpi-table-header">
                    <div className="kpi-table-title-container" onClick={()=>{ this.setState({ toggled:!this.state.toggled }) }}>
                        <i className={"fas fa-chevron-right"}/>
                        <div className="kpi-table-title">
                            { this.props.title }
                        </div>
                        {
                            this.props.counter ?
                                <div className="kpi-table-counter">
                                    { this.props.counter }
                                </div>
                            :
                                null
                        }
                    </div>
                    {
                        this.props.search &&
                        <div className="kpi-table-search">
                        </div>
                    }
                </div>
                <div className="kpi-table-value">
                    { this.props.children }
                </div>
            </div>
        )
    }

};
